import { Navigate } from 'react-router-dom';
import { IRoute, PORTAL_URL } from '@models';
import { PORTAL_ROUTES } from './Portal';
import { Login } from './Login';
import { Login2 } from './Login2';
import { ForgotPassword } from './ForgotPassword';
import { Invitation } from './Invitation';
import { Configurator } from './Configurator';
import { ResetPassword } from './ResetPassword';
import { ChangePassword } from './ChangePassword';
import { VerifyUser } from './VerifyUser';

export const ROUTES: IRoute[] = [
	{
		path: '/',
		element: <Navigate to={{ pathname: '/portal' }} replace />
	},
	{
		path: '/login',
		element: <Login />
	},
	{
		path: '/login2',
		element: <Login2 />
	},
	{
		path: '/invitation',
		element: <Invitation />
	},
	{
		path: '/verify-user/:email',
		element: <VerifyUser />
	},
	{
		path: '/configurator',
		element: <Configurator />
	},
	{
		path: '/forgot-password',
		element: <ForgotPassword />
	},
	{
		path: '/reset-password',
		element: <ResetPassword />
	},
	{
		path: '/change-password',
		element: <ChangePassword />
	},
	PORTAL_ROUTES,
	{
		path: '*',
		element: <Navigate to={{ pathname: `/${PORTAL_URL}` }} replace />
	}
];
